module.exports = "https://static.im-cdn.com/mjc/storefront/Sakra/static/media/DefaultProductImage.866052c2.png";